<style>
.add-owner {
  float: right;
}

.ranges {
  max-height: 200px;
  overflow: scroll;
}

.alert-primary {
  width: 100%;
}
</style>

<template>
  <div>
    <!-- Form Modal -->
    <b-modal
      ref="myModalPcn"
      centered
      no-close-on-backdrop
      no-close-on-esc
      :hide-footer="true"
      size="lg"
    >
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5>PCN Tickets</h5>
        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="PrinterIcon"
          size="16"
          @click="print()"
        />
        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="close()"
        />
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{}">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">SN</th>
              <th scope="col">Barcode</th>
              <th scope="col">NGrade</th>
              <th scope="col">HGrade</th>
              <th scope="col">Weight</th>
              <th scope="col">Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(tiket, index) in tikets">
              <th scope="row">
                {{ index + 1 }}
              </th>
              <td>{{ tiket.barcode }}</td>
              <td>{{ tiket.grade }}</td>
              <td>{{ tiket.houseGrade }}</td>
              <td>{{ tiket.mass }}</td>
              <td>{{ tiket.value.toFixed(2) }}</td>
            </tr>
          </tbody>

          <tfoot>
            <tr style="font-weight: bold">
              <td colspan="4" class="footer">&nbsp;</td>
              <td class="footer">
                {{ totalWeight.toFixed(2) }}
              </td>
              <td class="footer">
                {{ tValue.toFixed(2) }}
              </td>
            </tr>
          </tfoot>
        </table>
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>Filter Location</h5>
      </b-card-header>
      <b-card-body>
        <b-row v-if="user.levels.length > 0">
          <b-col cols="12">
            <location-filters size="sm" align="horizontal" @filter="changeFilter" />
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6" md="3">
            <b-form-group label-for="market_id" label="Market Center">
              <validation-provider #default="{ errors }" name="market_id" rules="">
                <b-form-select
                  id="market_id"
                  v-model="filter.market_id"
                  name="market_id"
                  size="sm"
                  @change="getAreaMarketSale(filter.market_id)"
                >
                  <b-form-select-option :value="null">Select...</b-form-select-option>
                  <b-form-select-option
                    v-for="market in markets"
                    :key="market.id"
                    :value="market.id"
                  >
                    {{ market.name.toUpperCase() }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small v-if="serverErrors && serverErrors.market_id" class="text-danger">{{ serverErrors.market_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6" md="3">
            <b-form-group label-for="sale_id" label="Sale">
              <validation-provider #default="{ errors }" name="sale_id" rules="">
                <b-form-select
                  id="sale_id"
                  v-model="filter.sale_id"
                  name="sale_id"
                  size="sm"
                  @change="changeSale($event)"
                >
                  <b-form-select-option :value="null">Select...</b-form-select-option>
                  <b-form-select-option
                    v-for="sale in sales"
                    :key="sale.id"
                    :value="sale"
                    >{{ sale.number }}</b-form-select-option
                  >
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small v-if="serverErrors && serverErrors.sale_id" class="text-danger">{{ serverErrors.sale_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6" md="3">
            <b-form-group label-for="society_id" label="Society">
              <validation-provider #default="{ errors }" name="society_id" rules="">
                <b-form-select
                  id="society_id"
                  v-model="filter.society_id"
                  name="society_id"
                  size="sm"
                  @change="changeSociet(filter.society_id)"
                >
                  <b-form-select-option :value="null">Select...</b-form-select-option>
                  <b-form-select-option
                    v-for="society in societies"
                    :key="society.id"
                    :value="society.id"
                  >
                    {{ society.name.toUpperCase() }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.society_id"
                  class="text-danger"
                  >{{ serverErrors.society_id[0] }}</small
                >
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="3">
            <b-form-group label-for="effectiveDate" label="Effective Date">
              <validation-provider #default="{ errors }" name="effectiveDate" rules="">
                <b-form-datepicker
                  id="effectiveDate"
                  v-model="filter.effectiveDate"
                  :min="minDate"
                  name="effectiveDate"
                  :state="errors.length > 0 ? false : null"
                  size="sm"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  locale="en"
                  :max="new Date().toISOString().substr(0, 10)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <small v-if="serverErrors && serverErrors.effectiveDate" class="text-danger">{{ serverErrors.effectiveDate[0] }}</small>
                <small v-if="serverErrors && serverErrors.agreement_ids" class="text-danger">{{ serverErrors.agreement_ids[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="3" class="pt-2">
            <b-button variant="primary" size="sm" @click="getPcn()" :disabled="updating">
              <span class="text-nowrap" v-if="!updating">Update Effective Date</span>
              <b-spinner small class="mr-1" label="Small Spinner" v-if="updating" />
              <span v-if="updating">Updating...</span>
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col cools="12">
            <small v-if="generalServerErrors" class="text-danger">{{ generalServerErrors }}</small>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- ./Filters -->

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>entries</label>
          </b-col>
          <!-- ./Per Page -->

          <b-col cols="6">
            <b-row class="d-flex justify-content-end">
              <!-- Search & Button -->
              <b-col cols="12" md="4" v-if="selectedItems.length > 0" class="px-0 d-flex justify-content-end">
                <b-button variant="primary" size="sm" @click="handleReceiveMultiple">
                  <span class="text-nowrap">Receive PCN ({{ selectedItems.length }})</span>
                </b-button>
              </b-col>

              <b-col cols="12" md="8">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    placeholder="Search..."
                    size="sm"
                  />
                </div>
              </b-col>
              <!-- ./Search & Button-->
            </b-row>
          </b-col>
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table
        ref="records"
        striped
        hover
        small
        class="position-relative"
        :items="fetch"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No records found"
        :sort-desc.sync="isSortDirDesc"
        @input="onTableInput"
      >
        <template #head(select)>
          <b-form-checkbox
            :checked="selectAll"
            :indeterminate="isIndeterminate"
            @change="toggleSelectAll"
          />
        </template>

        <!-- Row Checkbox -->
        <template #cell(select)="data">
          <b-form-checkbox
            :checked="selectedItems.includes(data.item.id)"
            @change="toggleSelect(data.item.id)"
          />
        </template>

        <template #cell(society)="data">
          {{ data.item.society.name.toUpperCase() }}
        </template>

        <template #cell(sale)="data">
          {{ data.item.sale.number }}
        </template>

        <template #cell(effectiveDate)="data">
          <span v-if="data.item.society.effective">{{ data.item.society.effective | moment('DD/MM/YYYY') }}</span>
          <span v-else>Not Updated</span>
        </template>

        <template #cell(received)="data">
          <span v-if="data.item.received">
            <b-badge variant="light-success" pill class="text-capitalize">
              Received
            </b-badge>
          </span>
          <span v-else>
            <b-badge variant="light-danger" pill class="text-capitalize">
              Not Received
            </b-badge>
          </span>
        </template>

        <template #cell(value)="data">
          <span v-if="data.item.tickets.length > 0">
            {{
              data.item.tickets
                .reduce((acc, ticket) => acc + parseFloat(ticket.value), 0)
                .toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3,
                })
            }}
          </span>
        </template>

        <template #cell(mass)="data">
          <span v-if="data.item.tickets.length > 0">
            {{
              data.item.tickets
                .reduce((acc, ticket) => acc + parseFloat(ticket.mass), 0)
                .toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
            }}
          </span>
        </template>

        <!-- Column: Actions -->

        <template #cell(actions)="data">
          <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
            <b-form-checkbox
              class="custom-control-success ml-4"
              name="check-button"
              switch
              :checked="data.item.received"
              @change="handleCheckboxChange($event, data.item.id)"
            >
              <span class="switch-icon-left">
                <feather-icon icon="CheckCircleIcon" />
              </span>
            </b-form-checkbox>

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="viewPcn(data.item.tickets, data.item)">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item @click="invokeUpdateForm(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BPagination,
  BForm,
  BFormGroup,
  BButton,
  BFormSelect,
  BFormSelectOption,
  BFormInput,
  BDropdown,
  BDropdownItem,
  BSpinner,
  BFormCheckbox,
  BBadge,
  BAlert,
  BFormDatepicker,
} from "bootstrap-vue";
import LocationFilters from "@core/components/cromis/filters/LocationFilters.vue";
import vSelect from "vue-select";
import { required } from "@validations";
import store from "@/store";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import receivePcnStoreModule from "@/views/cromis/sales/receive_pcn/receivePcnStoreModule";
import useReceivePcnsList from "@/views/cromis/sales/receive_pcn/useReceivePcnsList";
import Panel from "primevue/panel";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import moment from 'moment'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BPagination,
    // eslint-disable-next-line vue/no-unused-components
    BForm,
    BFormGroup,
    BButton,
    BFormSelect,
    BFormSelectOption,
    BFormInput,
    vSelect,
    BDropdown,
    BDropdownItem,
    // eslint-disable-next-line vue/no-unused-components
    BSpinner,
    // eslint-disable-next-line vue/no-unused-components
    ValidationObserver,
    ValidationProvider,
    BFormCheckbox,
    BBadge,
    BAlert,
    Panel,
    Accordion,
    AccordionTab,
    BFormDatepicker,
    LocationFilters,
  },
  directives: {},
  props: {},
  watch: {
    userInput(newInput, oldInput) {
      // Update default value when user input changes
      if (!isNaN(newInput)) {
        this.defaultValue -= newInput - oldInput;
      } else {
        // Handle case where userInput is NaN (e.g., after deleting the number)
        this.defaultValue = this.defaultValue;
      }
    },
  },
  setup(props, context) {
    const dataForm = ref(null);
    const myModalPcn = ref(null);
    const myViewModal = ref(null);
    const myRangeModal = ref(null);
    const saving = ref(false);
    const updating = ref(false);
    const serverErrors = ref(null);
    const generalServerErrors = ref(null);
    const totalMass = ref(null);
    const totalValue = ref(null);
    const errosOcurs = ref(null);

    const totalWeight = ref(0);
    const tValue = ref(0);
    const companies = ref([]);
    const societies = ref([]);
    const markets = ref([]);
    const requisitionDetail = ref(null);

    const sales = ref([]);
    const children = ref([]);
    const tikets = ref([]);
    const fullPcn = ref([]);
    const selectedItems = ref([]);
    const selectAll = ref(false);
    const now = new Date();
    const today = ref(new Date(now.getFullYear(), now.getMonth(), now.getDate()));
    const minDate = ref(new Date(today));
    const requisition = ref({
      requisition_id: null,
      type: null,
      ranges: [
        {
          start: null,
          end: null,
        },
      ],
    });

    const displayedRows = ref([]);
    const isIndeterminate = ref(false);

    const filter = ref({
      region_id: null,
      location_id: null,
      market_id: null,
      sale_id: null,
      society_id: null,
      effectiveDate: null,
    });

    const user = ref(JSON.parse(localStorage.getItem("userData")));
    const locId = ref(user.value.station.location);
    const role = ref(user.value.roles[0]);

    const CROMIS_STORE_MODULE_NAME = "cromis-receive";
    // Register module
    if (!store.hasModule(CROMIS_STORE_MODULE_NAME))
      store.registerModule(CROMIS_STORE_MODULE_NAME, receivePcnStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CROMIS_STORE_MODULE_NAME))
        store.unregisterModule(CROMIS_STORE_MODULE_NAME);
    });

    onMounted(async () => {
      await store.dispatch("cromis-receive/markets", {location_id: locationFilter !== null ? locationFilter.value : null})
        .then((response) => {
          markets.value = response.data.markets;
        })
        .catch((error) => {
          console.log("got error", error);
        });
    });

    const changeFilter = async (filteredValue) => {
      locationFilter.value = filteredValue !== null? filteredValue.id : null

      filter.value.effectiveDate = null
      filter.value.sale_id = null
      filter.value.society_id = null
      
      await store.dispatch("cromis-receive/markets", {location_id: filteredValue !== null ? filteredValue.id : null})
        .then((response) => {
          markets.value = response.data.markets;
        })
        .catch((error) => {
          console.log("got error", error);
        });
    };

    const onTableRefreshed = (items) => {
      displayedRows.value = items || [];
      syncHeaderCheckbox();
    };

    const onTableInput = (items) => {
      displayedRows.value = items || [];
      syncHeaderCheckbox();
    };

    const syncHeaderCheckbox = () => {
      const ids = displayedRows.value.map((r) => r.id);
      if (ids.length === 0) {
        selectAll.value = false;
        isIndeterminate.value = false;
        return;
      }

      const selectedCount = ids.filter((id) => selectedItems.value.includes(id)).length;

      selectAll.value = selectedCount === ids.length;
      isIndeterminate.value = selectedCount > 0 && selectedCount < ids.length;
    };

    const {
      fetch,
      columns,
      perPage,
      currentPage,
      totalRecords,
      from,
      to,
      meta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      records,
      refetch,

      // Filers
      resolveStatusVariant,
      resolveReceivedVariant,
      locationFilter,
      marketFilter,
      saleFilter,
      societyFilter,
      selectedEffectiveDate,
    } = useReceivePcnsList();

    // Form Methods
    const viewPcn = (item, pcn) => {
      fullPcn.value = pcn;
      tikets.value = item;

      totalWeight.value = 0;
      tValue.value = 0;
      for (let index = 0; index < tikets.value.length; index++) {
        totalWeight.value += parseFloat(tikets.value[index].mass);
        tValue.value += parseFloat(tikets.value[index].value);
      }

      myModalPcn.value.show();
    };

    const print = async () => {
      console.log(fullPcn.value);
      const data = {
        agreements: [fullPcn.value.id],
        report_id: 1,
      };
      console.log(data);

      await store
        .dispatch("cromis-receive/createPrint", data)
        .then((response) => {
          context.root.$swal({
            icon: "success",
            text: "Sales Document prints initialized!",
            showConfirmButton: true,
            timer: 5000,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.log(error);
          saving.value = false;
          if (error.response.status === 422) {
            serverErrors.value = error.response.data.errors;
          } else {
            context.root.$swal({
              icon: "error",
              title: "Server Error",
              text: "Something went wrong. See tech support",
              showConfirmButton: true,
              customClass: {
                confirmButton: "btn btn-danger",
              },
              buttonsStyling: false,
            });
          }
        });
    };

    const itemsProvider = async (ctx) => {
      const items = await fetch(ctx); // fetch is your existing provider from useReceivePcnsList
      displayedRows.value = items || [];
      syncHeaderCheckbox();
      return items;
    };

    const toggleSelect = (id) => {
      if (selectedItems.value.includes(id)) {
        selectedItems.value = selectedItems.value.filter((x) => x !== id);
      } else {
        selectedItems.value.push(id);
      }
      syncHeaderCheckbox();
    };

    const toggleSelectAll = (checked) => {
      const ids = displayedRows.value.map(r => r.id)
      if (ids.length === 0) return

      if (!checked) {
        selectedItems.value = selectedItems.value.filter(id => !ids.includes(id))
      } else {
        const set = new Set(selectedItems.value)
        ids.forEach(id => set.add(id))
        selectedItems.value = Array.from(set)
      }

      syncHeaderCheckbox()
    }


    const getTotalValue = (valueArray) => {
      console.log(valueArray);
      totalValue.value = 0;
      for (let index = 0; index < valueArray.length; index++) {
        totalValue.value = valueArray[index].mass;
      }
      // valueArray.forEach(ele => {
      //     totalValue.value += ele.value;
      // });

      return totalValue.value;
    };

    const getTotalMass = (massArray) => {
      totalMass.value = 0;
      // console.log(massArray)
      // massArray.forEach(ele => {
      //     totalMass.value += ele.mass;
      // });

      for (let index = 0; index < massArray.length; index++) {
        totalMass.value = massArray[index].value;
      }

      return totalMass.value;
    };
    const invokeUpdateForm = (item) => {
      console.log(item);
    };

    const getPcn = async () => {
      let mySale = filter.value.sale_id
      filter.value.sale_id = filter.value.sale_id.id;
      console.log(filter.value.sale_id);
      const data = {
        effectiveDate: filter.value.effectiveDate,
        society_id: filter.value.society_id,
        sale_id: filter.value.sale_id,
      };
      console.log(data);

      updating.value = true
      await store.dispatch("cromis-receive/effectiveDate", data)
        .then((response) => {
          refetch();
          updating.value = false;

          filter.value.sale_id = mySale

          context.root.$swal({
            icon: "success",
            text: "Effective date is associated has been made successfully!",
            showConfirmButton: true,
            timer: 3000,
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          updating.value = false;
          errosOcurs.value = error.response.data;

          if (error.response.status === 422) {
            serverErrors.value = error.response.data.errors;

            console.log(serverErrors);
          } else {
            context.root.$swal({
              icon: "error",
              title: "Server Error",
              text: "Something went wrong. See tech support",
              showConfirmButton: true,
              customClass: {
                confirmButton: "btn btn-danger",
              },
              buttonsStyling: false,
            });
          }
        });
    };

    const handleCheckboxChange = async (event, id) => {
      const payload = {
        received: event,
      };

      await store
        .dispatch("cromis-receive/update", { id, data: payload })
        .then((response) => {
          console.log(response);
          refetch();
          saving.value = false;
          serverErrors.value = null
          generalServerErrors.value = null

          context.root.$swal({
            icon: "success",
            text: "Changes to PCN has been saved successfully!",
            showConfirmButton: true,
            timer: 3000,
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          saving.value = false;
          if (error.response.status === 422) {
            serverErrors.value = error.response.data.errors;

            Object.keys(serverErrors.value).forEach(key => {
              generalServerErrors.value = serverErrors.value[key][0]
            })

          } else {
            serverErrors.value = null
            generalServerErrors.value = null
            context.root.$swal({
              icon: "error",
              title: "Server Error",
              text: "Something went wrong. See tech support",
              showConfirmButton: true,
              customClass: {
                confirmButton: "btn btn-danger",
              },
              buttonsStyling: false,
            });
          }
        });
    };

    const handleReceiveMultiple = async () => {
      const agreement_ids = selectedItems.value;

      const payload = {
        received: true,
        agreement_ids, // [1,2,3,...]
      };

      console.log("RECEIVE MULTIPLE PAYLOAD", payload);

      // Example dispatch (you implement backend action)

       await store
        .dispatch("cromis-receive/receiveMultiple", payload)
        .then((response) => {
          refetch();
          saving.value = false;

          context.root.$swal({
            icon: "success",
            text: "PCNs have been received successfully!",
            showConfirmButton: true,
            timer: 3000,
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          saving.value = false;
          errosOcurs.value = error.response.data;
          console.log(error.response);
          if (error.response.status === 422) {
            serverErrors.value = error.response.data.errors;

            console.log(serverErrors);
          } else {
            context.root.$swal({
              icon: "error",
              title: "Server Error",
              text: "Something went wrong. See tech support",
              showConfirmButton: true,
              customClass: {
                confirmButton: "btn btn-danger",
              },
              buttonsStyling: false,
            });
          }
        });
    };

    const getAreaMarket = async () => {
      locationFilter.value = filter.value.location_id;
      await store
        .dispatch("cromis-receive/markets", { location_id: filter.value.location_id })
        .then((response) => {
          markets.value = response.data.markets;

          console.log(response);
        })
        .catch((error) => {
          console.log("got error", error);
        });

        filter.value.effectiveDate = null
        filter.value.sale_id = null
        filter.value.society_id = null
    };

    const getAreaMarketSale = async () => {
      marketFilter.value = filter.value.market_id;
      await store
        .dispatch("cromis-receive/sales", { market_id: filter.value.market_id })
        .then((response) => {
          sales.value = response.data.sales;
          societies.value = response.data.sales.societies;
          console.log(response);
        })
        .catch((error) => {
          console.log("got error", error);
        });

        filter.value.effectiveDate = null
        filter.value.sale_id = null
        filter.value.society_id = null
    };

    const changeSociet = async (id) => {
      societyFilter.value = id;

      if(filter.value.sale_id !== null){
       filter.value.effectiveDate = selectedEffectiveDate.value
      }
      else{
        filter.value.effectiveDate = null
      }
    };

    const changeSale = async (event) => {
      minDate.value = new Date(event.saleDate);
      saleFilter.value = event.id;
      societies.value = event.societies;
      
      if(filter.value.society_id !== null){
       filter.value.effectiveDate = selectedEffectiveDate.value 
      }
      else{
        filter.value.effectiveDate = null
      }
    };

    const changeRegion = async (event) => {
      locId.value = event;
      locationFilter.value = event.id;
      filter.value.effectiveDate = null
      filter.value.sale_id = null
      filter.value.society_id = null
    };

    const isFormValid = async () => {
      let isValid = false;
      await dataForm.value.validate().then((success) => {
        isValid = success;
      });

      return isValid;
    };

    const handleCreate = async () => {
      saving.value = true;
      const valid = await isFormValid();

      if (!valid) {
        saving.value = false;
      }
    };

    const handleApprove = async (item) => {
      saving.value = true;

      const data = {
        approved: true,
      };

      console.log(item);
      console.log(data);

      await store
        .dispatch("cromis-receive/update", { id: item.id, data })
        .then((response) => {
          refetch();
          saving.value = false;

          context.root.$swal({
            icon: "success",
            text: "Approved has been made successfully!",
            showConfirmButton: true,
            timer: 3000,
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          saving.value = false;
          errosOcurs.value = error.response.data;
          console.log(error.response);
          if (error.response.status === 422) {
            serverErrors.value = error.response.data.errors;

            console.log(serverErrors);
          } else {
            context.root.$swal({
              icon: "error",
              title: "Server Error",
              text: "Something went wrong. See tech support",
              showConfirmButton: true,
              customClass: {
                confirmButton: "btn btn-danger",
              },
              buttonsStyling: false,
            });
          }
        });
    };

    const remove = async (id) => {
      await store
        .dispatch("cromis-receive/remove", id)
        .then((response) => {
          refetch();
        })
        .catch((error) => {
          context.root.$swal({
            icon: "error",
            title: "Server Error",
            text: "Something went wrong. See tech support",
            showConfirmButton: true,
            customClass: {
              confirmButton: "btn btn-danger",
            },
            buttonsStyling: true,
          });
        });
    };

    const approveRequisition = (item) => {
      console.log(item);
      handleApprove(item);
    };
    const submit = (bvModalEvt) => {
      bvModalEvt.preventDefault();

      serverErrors.value = null;
      handleCreate();
    };

    return {
      // Data
      requisition,

      selectedOwner: null,
      clientName: JSON.parse(localStorage.getItem("userData")).client,
      options: [
        { value: null, text: "-- Select Box Type --" },
        { value: "1", text: "Bale Ticket" },
        { value: "2", text: "Luggage" },
      ],
      fetch,
      columns,
      perPage,
      currentPage,
      totalRecords,
      from,
      to,
      meta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      records,
      refetch,
      resolveStatusVariant,
      resolveReceivedVariant,

      // Methods

      required,
      saving,
      updating,
      serverErrors,
      generalServerErrors,
      dataForm,
      myModalPcn,
      myViewModal,
      requisitionDetail,
      changeFilter,
      filter,
      markets,
      sales,
      changeSale,
      changeSociet,
      changeRegion,
      myRangeModal,
      locationFilter,
      marketFilter,
      saleFilter,
      societyFilter,
      viewPcn,
      approveRequisition,
      submit,
      isFormValid,
      handleCreate,
      companies,
      societies,
      errosOcurs,
      locId,
      user,
      role,
      getAreaMarket,
      getAreaMarketSale,
      handleApprove,
      minDate,
      getPcn,
      handleCheckboxChange,
      getTotalMass,
      getTotalValue,
      totalMass,
      totalValue,
      tikets,
      totalWeight,
      tValue,
      invokeUpdateForm,
      fullPcn,
      print,
      selectedItems,
      selectAll,
      toggleSelect,
      toggleSelectAll,
      handleReceiveMultiple,
      displayedRows,
      isIndeterminate,
      onTableRefreshed,
      syncHeaderCheckbox,
      toggleSelect,
      itemsProvider,
      onTableInput,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
